import React,{ useEffect } from 'react';
import { useState } from 'react';
import DataTable from 'react-data-table-component';



const Table=({data, columns, setData, selected=[]})=> {

    const [searchTerm, setSearchTerm]=useState("")
    const [render, setRender] = useState(false)
    const [selectedRows, setSelectedRows] = useState([])
    const handleRowSelected = React.useCallback(state => {
        // setData(state.selectedRows)
		setSelectedRows(state.selectedRows);
	}, []);
    useEffect(()=>{
        setRender(true)
    },[])

    useEffect(()=>{
        setData(selectedRows)
        
        // setData(selectedRows)
    },[selectedRows])

	return (
        <>
        {(render)? 
            <>
                <div className="justify-end">
                    <input type="search" 
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                     placeholder="Search..."
                     onChange={(e)=>{
                        setSearchTerm(e.target.value);
                     }}/>
                </div>
                <DataTable
                    pagination
                    columns={columns}
                    pageSize={5}
                    // data={data}
                    // selectableRowSelected={selected}
                    selectableRows
                    onSelectedRowsChange={handleRowSelected}
                    data={data.filter((item) => {
                        if (searchTerm === "") {
                        return item;
                        } else if (
                        item?.name.toLowerCase().includes(searchTerm.toLowerCase())
                        ) {
                        return item;
                        }
                    })}
                />
            </>
            :
            <></>}
        </>
	);
};
export default Table;

